import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RestService } from 'src/app/services/rest.service';
import { VideoStorageService } from 'src/app/services/video-storage.service';
import { ImageStorageService } from 'src/app/services/image-storage.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class SlidesService {

    public containerWidth: any;
    public containerHeight: any;
    public grids: any;
    public filteredGrids = [];
    public reels: any;
    // HRS-3472: URLs del servidor que ya fallaron. Vive en el servicio (raíz) para que
    // sobreviva al cambio de slide; se vacía con el reinicio diario del navegador.
    public failedRemoteUrls = new Set<string>();

    constructor(
        private sanitizer: DomSanitizer, 
        public rest: RestService,
        private videoStorageService: VideoStorageService,
        private imageStorageService: ImageStorageService,
    ) {}

    async setSlides(){
        const url = this.rest.apiUrlBase;
        this.containerWidth = parseInt((this.rest?.device?.reels?.items?.size?.width || this.reels?.size?.width), 10) ?? 1080;
        this.containerHeight = parseInt((this.rest?.device?.reels?.items?.size?.height || this.reels?.size?.height), 10) ?? 1920;
        this.grids = structuredClone((this.rest?.device?.reels?.items?.data || this.reels?.data) ?? [])
        await Promise.all(this.grids.map(async grid => {
            switch (grid.transition) {
                case 'slide': grid.transition = 'slideAnimation'; break;
                case 'fade': grid.transition = 'fadeAnimation'; break;
                case 'none': grid.transition = 'noAnimation'; break;
                default: grid.transition = 'slideAnimation'; break;
            }

            const structs = grid.structure || [];
            grid.structure = await Promise.all(structs.map(async e => {
                if (e.type === 'web') 
                    return e;

                return {
                    ...e,
                    srcServer: url + e.src,
                    srcLocal: await this.getLocalUrl(e.src, e.type)
                };
            }));
        }));

        this.filterGrids();
    }

    getStyle(structure){
        return {
            width: (this.containerWidth/12) * structure?.w,
            height: (this.containerHeight/12) * structure?.h,
            left: (this.containerWidth/12) * structure?.x,
            top: (this.containerHeight/12) * structure?.y,
            muted: structure?.muted,
            loop: structure?.loop
        }
    }

    filterGrids(){
        const actualData =  this.grids?.filter(grid => {
            return !grid.hasOwnProperty('hours') || 
                grid.hours?.length == 0 ||
                grid.hours?.some(hours => {
                    const day = moment(hours.start, 'HH:mm') >= moment(hours.end, 'HH:mm') ? 1 : 0;
                    const endMoment = day === 1 ? moment(hours.end, 'HH:mm').add(1, 'days') : moment(hours.end, 'HH:mm');
                    return hours.days[moment().day()] && moment().isBetween(moment(hours.start, 'HH:mm'), endMoment)
                })
        });
        this.filteredGrids = structuredClone(actualData);
    }

    async getLocalUrl(url: string, type: string) {
        const src = url.split('/');
        const fileName = src?.[src?.length - 1];
        // Sin blob en IndexedDB, la copia local es la que baja get_reels_sliders.sh a /var/www/html/assets/.
        // Sin el prefijo se pedía /<fichero> (404) y el vídeo caía al servidor en cada vuelta del bucle.
        const srcLocal = 'assets/' + fileName;

        if (type === 'video'){
            const blob = await this.videoStorageService.getVideo(fileName);
            if (!blob)
                return srcLocal;
    
            const objectURL = URL.createObjectURL(blob);
            return objectURL;
        }

        if (type === 'image'){
            const blob = await this.imageStorageService.getImage(fileName);
            if (!blob)
                return srcLocal;
            
            const objectURL = URL.createObjectURL(blob);
            return objectURL;
        }

        return srcLocal;
      }

}